import React, { useContext } from "react"
import { PageHeader, TitleWithIcon } from "../molecules/Molecules"
import { HR, Spacer } from "../atoms/Atoms"
import { ChangePasswordContainer } from "../../containers/account/ChangePasswordContainer"
import { BankDetails } from "./BankDetails"
import Address from "./Address"
import PersonalInformation from "./PersonalInformation"
import PartnerDetails from "./PartnerDetails"
import styled from "styled-components"
import L10n from "../../../lib/carrot-l10n"
import { useFormContext } from "react-hook-form"
import { AccountSettingsContext } from "../../containers/account/AccountSettingsContainer"
import { MasterLayout } from "../atoms/layouts/MasterLayout"
import { Button } from "../atoms/buttons/Button"
import { useSelector } from "react-redux"
import { getCompanyInfo } from "reducers/companyInfo"
import { FeatureGate } from "utils/FeatureGate"
import { CommunicationSettings } from "./CommunicationSettings"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const SubmitFooter = () => {
  const { isSubmitted, onSubmit } = useContext(AccountSettingsContext)
  const {
    formState: { isDirty, isSubmitting }
  } = useFormContext()

  const backgroundColor = isDirty || isSubmitted ? "carrot-orange" : "black-10"
  const buttonText = isSubmitting
    ? l`client.saving`
    : isDirty
    ? l`client.accountSettings.saveChanges`
    : l`client.changesSaved`

  return (
    <>
      <Spacer height={2.5} />
      <div className="tr">
        <Button
          id="account-settings-submit-button"
          color="white"
          hoverBackgroundColor={isDirty ? backgroundColor : null}
          backgroundColor={backgroundColor}
          onClick={isDirty ? onSubmit : null}
        >
          {buttonText}
        </Button>
      </div>
      <Spacer height={5.125} />
    </>
  )
}

const AccountSettingsHeader = () => (
  <PageHeader title={l`client.account.settings`} icon="icn-account-settings">
    <TitleWithIcon />
  </PageHeader>
)

const StyledHR = styled.div`
  margin-top: 17.5px;
  margin-bottom: 33.5px;
`

const AccountSettingsWrapper = styled.div`
  max-width: 600px;
`

const AccountHR = () => (
  <StyledHR>
    <HR color="black-20" />
  </StyledHR>
)

const AccountSettingsBody = () => {
  const { isSamlActive } = useSelector(getCompanyInfo)

  return (
    <AccountSettingsWrapper>
      <PersonalInformation />
      <AccountHR />
      {!isSamlActive && (
        <>
          <ChangePasswordContainer />
          <AccountHR />
        </>
      )}
      <FeatureGate filter={(c) => c.isPartnerEnabled}>
        <PartnerDetails />
        <AccountHR />
      </FeatureGate>
      <Address />
      <FeatureGate filter={(c) => c.isBankInfoEnabled}>
        <AccountHR />
        <BankDetails />
      </FeatureGate>
      <AccountHR />
      <CommunicationSettings />
      <SubmitFooter />
    </AccountSettingsWrapper>
  )
}

const AccountSettings = () => (
  <MasterLayout header={<AccountSettingsHeader />}>
    <AccountSettingsBody />
  </MasterLayout>
)

export default AccountSettings
